export const faqs = [
  {
    question: `Que signifie « shiatsu » ?`,
    answer: [`« Pression des doigts » en japonais. `],
  },
  {
    question: `D’où vient la pratique du shiatsu ?`,
    answer: [
      `Du Japon où traditionnellement il était reçu comme traitement préventif pour rester en bonne santé.`,
    ],
  },
  {
    question: `A quoi sert le shiatsu ?`,
    answer: [
      `A guérir les forces vitales du corps, à augmenter les défenses immunitaires pour ne pas tomber malade ou pour que le corps puisse s’auto-guérir sans intervention médicamenteuse, à se sentir apaisé et unifié.`,
    ],
  },
  {
    question: `Quelle action a le shiatsu ?`,
    answer: [
      `Par la pression des doigts le long des méridiens d’acupuncture le praticien fait circuler l’énergie, tonifiant ou dispersant selon les besoins certains méridiens ou certains points d’acupuncture. Il en résulte une augmentation des défenses immunitaires, de l’énergie et une harmonisation de l’état général.`,
    ],
  },
  {
    question: `Quelle est la différence entre un shiatsu et un massage ?`,
    answer: [
      `Un massage est superficiel, il offre une détente ponctuelle. Le shiatsu est thérapeutique, ses pressions agissent sur la circulation de l’énergie et soignent. C’est une médecine alternative.`,
    ],
  },
  {
    question: `Quel type de shiatsu ?`,
    answer: [
      `Le Sei Shiatsu développé par Bernard Bouheret, kinésithérapeute et praticien en shiatsu diplômé de Koho Shiatsu (école Hakko de Maître Okuyama) et enseigné à l'École de shiatsu thérapeutique (Paris).`,
    ],
  },
  {
    question: `Quelle est la durée d’une séance de shiatsu ?`,
    answer: [`75 minutes.`],
  },
  {
    question: `En quoi consiste une séance ?`,
    answer: [
      `Après interrogatoire et prise des 12 pouls suit un protocole de pressions du haut du dos jusqu’à la plante des pieds pour faire descendre l’énergie Yang (Ciel) puis de la plante des pieds jusqu’en haut de la tête et jusqu’au bout des mains pour remonter l’énergie Yin (Terre) avec insistances selon besoins sur certains méridiens et points d’acupuncture en particulier.`,
    ],
  },
  {
    question: `Une seule séance peut-elle suffire ?`,
    answer: [
      `Le nombre de séances varie en fonction de l’état d’ancienneté de la fatigue, du caractère ponctuel ou chronique des maux dont on souffre.`,
    ],
  },
  {
    question: `A quelle fréquence peut-on recevoir un shiatsu ?`,
    answer: [
      `Plus il y aura de déséquilibres liés au stress et à une mauvaise hygiène de vie, plus les séances devront être fréquentes et rapprochées pour maintenir un état de bien-être et de bonne énergie.`,
    ],
  },
  {
    question: `Est-ce qu’un shiatsu peut faire mal ?`,
    answer: [
      `Il peut arriver que certaines pressions soient sensibles voire douloureuses en fonction de l’état de circulation de l’énergie dans les méridiens. Le praticien adapte sa pression pour ne pas faire souffrir le receveur.`,
    ],
  },
  {
    question: `Est-il normal que des symptômes surviennent après une première séance ?`,
    answer: [
      `Des réactions sont souvent indispensables pour un rétablissement satisfaisant, ainsi, plus l’état global sera déséquilibré plus le risque sera grand d’avoir un contre-coup ponctuellement douloureux ou fatigant. Cela disparaît ou s’estompe dès la deuxième séance.`,
    ],
  },
  {
    question: `Que peut le shiatsu  quand on souffre d’une maladie chronique ?`,
    answer: [
      `Des séances régulières renforceront l’énergie, allègeront ou feront disparaître certains symptômes.`,
    ],
  },
  {
    question: `Doit-on se dévêtir pour recevoir un shiatsu ?`,
    answer: [
      `On reste vêtu pour recevoir un shiatsu. Il est recommandé d’apporter une paire de chaussettes quand on vient nu-pieds.`,
    ],
  },
  {
    question: `Y a-t-il une limite d’âge pour recevoir un shiatsu ?`,
    answer: [
      `Un bébé ou une personne âgée peuvent recevoir un shiatsu. Quel que soit l’âge et l’état de santé de la personne le shiatsu sera toujours bénéfique.`,
    ],
  },
  {
    question: `Le shiatsu est-il compatible avec d’autres traitements ?`,
    answer: [
      `Il est toujours un complément très bénéfique et aide à dissiper les effets de certains traitements lourds comme par exemple la chimiothérapie.`,
    ],
  },
  {
    question: `Le shiatsu est-il complémentaire à d’autres traitements ?`,
    answer: [
      `Oui, en rétablissant la circulation de l’énergie et en augmentant les forces vitales il complémente les autres traitements et permet un rétablissement plus prompt ou un allègement des effets indésirables, parfois même un allègement des traitements allopathiques. Il est également un excellent complément à un traitement psychothérapique ou à un suivi naturopathique ou diététique car l’énergie qu’il restitue permet de soutenir ces traitements parfois longs et éprouvants.`,
    ],
  },
  {
    question: `Peut-on recevoir un shiatsu durant une grossesse ?`,
    answer: [
      `Le shiatsu est un extraordinaire accompagnement pour la femme et l’enfant qu’elle porte. Le bébé naîtra et grandira paisible et les symptômes liés à la grossesse et au post-partum disparaîtront ou seront allégés. Un suivi permet d’éviter le baby-blues résultant d’un épuisement de l’énergie du Rein et une récupération rapide.`,
    ],
  },
  {
    question: `Est-il possible de parler durant un shiatsu ?`,
    answer: [
      `Un shiatsu permet de se détendre profondément et d’entrer en soi-même, cependant une séance de shiatsu peut aussi être un moment d’échanges liés à l’apaisement et au lâcher-prise. `,
    ],
  },
  {
    question: `Peut-on s’endormir durant un shiatsu ?`,
    answer: [
      `Si la fatigue et le lâcher-prise amènent à dormir, il n’y a aucune contre-indication à cela. Les effets n’en seront pas moins bénéfiques, bien au contraire.`,
    ],
  },
  {
    question: `Le shiatsu se reçoit-il sur une table de massage ?`,
    answer: [
      `Traditionnellement le shiatsu se reçoit allongé au sol sur un futon. Si cela n’est pas possible, un lit futon est à disposition. Il est aussi possible de recevoir un shiatsu assis sur une chaise.`,
    ],
  },
  {
    question: `Quels moyens de paiement ?`,
    answer: [`Espèces ou chèques uniquement.`],
  },
  {
    question: `Peut-on se garer facilement ?`,
    answer: [
      `Le long des trottoirs on peut se garer sans payer, éviter les places des résidents marquées au sol.`,
    ],
  },
  {
    question: `La praticienne est-elle ponctuelle à l’heure de mon rendez-vous ?`,
    answer: [
      `Je suis toujours à l’heure pour chaque rendez-vous, je prévois un espacement suffisant entre les séances pour l’aération et pour ne pas faire attendre.`,
    ],
  },
];
